<template lang="html">

<b-container fluid>
<b-row>
  <b-col md="6" offset-md="6" d-flex h-100 flex-wrap>

  <a href="#" class="btn" v-b-tooltip title="Log out" v-on:click.prevent="logOut">
    <font-awesome-layers class="fa-fw fa-3x">
     <font-awesome-icon icon="circle" class="blade-blue"/>
     <font-awesome-icon icon="sign-out-alt" style="color:#fff"  transform="shrink-5.0"/>
</font-awesome-layers>
  </a>
  </b-col>
</b-row>
    <b-row>
        <b-col md="4" offset-md="4" align-self="center"  d-flex h-100 flex-wrap >
          <b-img src="../assets/480x320-blade.png" center fluid alt="Responsive image" style=" margin-top:5%"/>
          <b-card title=""  sub-title="" style=" margin-top:3%">
            <h5 v-show="!activeSessions.length" class="blade-blue">No Seats Available</h5>
            <h5 v-show="activeSessions.length" class="blade-blue">All available seats are in use by the following users:</h5>
            <b-list-group v-show="activeSessions.length">
              <b-list-group-item v-for="session in activeSessions" :key = "session.id">{{session.userName}}</b-list-group-item>
            </b-list-group>
            <div class="loader"> <stretch v-if="busy" ></stretch> </div>
            <b-alert :show="hasError" variant="danger" @dismissed="hasError=false">
              {{errorMsg}}
            </b-alert>
          </b-card>
        </b-col>
    </b-row>
 </b-container>
</template>

<script lang="js">

import { Stretch } from 'vue-loading-spinner'

export default {
  name: 'select-instance',
  components: {
    Stretch
  },
  props: [],
  mounted: async function () {
    const self = this

    try {
      self.hasError = false
      self.busy = true
      const response = await self.$appStream.getActiveSessions()
      let activeSessions = response.data
      this.activeSessions = activeSessions
      console.log(response.data)

      self.busy = false
    } catch (error) {
      self.busy = false
      self.hasError = true
      self.errorMsg = 'an error occurred retrieving active sessions. refresh page and try again or contact your administrator'
    }
  },
  data () {
    return {

      activeSessions: [],
      errorMsg: '',
      hasError: false,
      busy: false,
      instanceOptions: { }
    }
  },
  methods: {

    logOut: async function () {
      let self = this
      await self.$auth.logOut()
      self.$router.push('/')
    }
  },
  computed: {

  }
}
</script>

<style src="../assets/styles.css"></style>



// WEBPACK FOOTER //
// src/components/ActiveSessions.vue